import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getToken } from '../../../config/token';
import { Request } from '../../../config/requests';
import { showToast } from '../../../config/helpers';
import Loading from '../../../components/common/Loading';
import { isMobileOnly } from 'react-device-detect';

const RemoveDunningsAll = ({ onBack, onCloseModal }) => {
    const { t } = useTranslation();
    const token = getToken();

    const [policyNo, setPolicyNo] = useState('');
    const [email, setEmail] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);

    const handleConfirm = async () => {
        setIsUpdating(true);
        try {
            const res = await Request({
                method: 'DELETE',
                route: `api/dunnings/${policyNo.trim()}/email/${email.trim()}`,
                token
            });
            const data = await res.json();

            if (!res.ok) {
                const errMsg = data.message || data.error || t('somethingWentWrong');
                showToast(errMsg, { error: true });
                return;
            }

            showToast(t('Dunnings removed successfully'), { success: true });
            setIsCompleted(true); // show success screen
        } catch (err) {
            const errMsg = err.message || t('somethingWentWrong');
            showToast(errMsg, { error: true });
        } finally {
            setIsUpdating(false);
        }
    };

    if (isCompleted) {
        return (
            <>
                <div
                    className="modal_container__body__text"
                    style={{ maxWidth: '500px', margin: '40px 0', textAlign: 'start' }}
                >
                    {t('Dunnings removed successfully!')}
                </div>
                <div className="modal_container__body__row-modal d-flex gap-3">
                    <div
                        className={`button_red_small ${isMobileOnly ? 'mobile' : ''}`}
                        onClick={() => onCloseModal?.()}
                    >
                        {t('OK')}
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className="wrapper w-100 d-flex gap-4 flex-column h-auto">
            <div className="modal_container__body__inputs align-items-start">
                <label htmlFor="remove-policy-no">{t('Policy Number')}</label>
                <input
                    id="remove-policy-no"
                    className="modal_container__body__input w-100"
                    placeholder="123456789"
                    value={policyNo}
                    onChange={e => setPolicyNo(e.target.value)}
                />
            </div>

            <div className="modal_container__body__inputs align-items-start">
                <label htmlFor="remove-email">{t('Email')}</label>
                <input
                    id="remove-email"
                    type="email"
                    className="modal_container__body__input w-100"
                    placeholder="you@example.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                />
            </div>

            <div className="modal_container__body__row-modal d-flex gap-3">
                {isUpdating ? (
                    <Loading noText fast width="100%" scroll={false} />
                ) : (
                    <>
                        <button
                            className="button_red_small__admin w-100"
                            disabled={!policyNo || !email}
                            onClick={handleConfirm}
                        >
                            {t('Remove all dunnings')}
                        </button>

                        <button className="button_red_small w-100" onClick={onBack}>
                            {t('Back')}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default RemoveDunningsAll;
